import React, {Component} from 'react';
import Tableros from './Boards/Tableros';
import Tablero from './Boards/Tablero';
import {Redirect, Route} from 'react-router-dom';
import TopTab from '../Containers/Nav/TopTab';
import Topnav from '../Containers/Nav/Topnav';
import Menu from './Menu/Menu';
import Calendar from 'react-calendar';
import Admin from './Admin/Admin';
import AddCards from './AddCards/AddCards';

class VisualApp extends Component {
  constructor() {
    super();
    this.state = {
      calendarState: "closed",
      date: null,
      selectedTab: false,
      availableTab: false,
      selectedVisuales: false,
    }
  }
  selectTablero = (vis, tab) => {
    this.setState({selectedTab: tab, selectedVisuales: vis})
  }
  openCalendar = () => {
    (this.state.calendarState === "open")
    ?this.setState({calendarState: "closed"})
    :this.setState({calendarState: "open"});
  }
  changeDate = (date) => {
    let dateISO = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
    this.props.db("tableros-home", false, dateISO)
    this.setState({calendarState: "closed", date: date});
  }
  reloadTabs = () => {
    this.props.db("tableros-home");
    this.props.msg("ok", "e07");
  }

  render () {
    let {lang, db, tab, vis, readVis, url, tkn, locale, langtxt, msg, uPer, uID} = this.props;
    let toptabtext = langtxt.home;
    let toptext = [toptabtext.Tab[lang], toptabtext.Vis[lang]];
    return (
      <div id="visualapp">
      {
        !this.props.loged
        ? <Redirect to="/" push={true}/>
        : null
      }
        <Route path='/home/tableros' render={() => {
          return (
            <div className="tablerosList">
              <TopTab col={toptext}/>
              <Tableros 
                db={db} 
                tab={tab}
                vis={vis}
                readVis={readVis}
                url={url}
                tkn={tkn}
                locale={locale} 
                langtxt={langtxt}
                lang={lang}
                date={this.state.date}
                selectTablero={this.selectTablero}
                msg={msg}
              />
              <Menu 
                locale={locale} 
                uPer={uPer}
                openCalendar={this.openCalendar} 
                date={this.state.date}
                logout={this.props.logOut}
                type="tableros"
              />
              <Calendar 
                className={this.state.calendarState} 
                locale={locale} 
                onChange={this.changeDate} />
            </div>
        )}}/>
      <Route path="/home/tableros/add" exact render={props => (
                <AddCards 
                date={this.state.date}
                locale={locale}
                tab={tab} 
                vis={vis} 
                readVis={readVis}
                url={url}
                tkn={tkn}
                reload={this.reloadTabs}
                msg={msg}
                />
      )}/>
      <Route path='/home/show/:id' render={() => {
        return(
          <div className="tablerosList">
            <Topnav 
              tab={tab}
              selectTablero={this.selectTablero}
              selectedTab={this.state.selectedTab} />
            <Tablero 
              uID={uID}
              tab={this.state.selectedTab} 
              vis={this.state.selectedVisuales} 
              date={this.state.date}
              avTabs={tab} 
              url={url}
              db={db}
              tkn={tkn}
              msg={msg}/>
            <Menu 
              locale={locale} 
              uPer={uPer}
              openCalendar={this.openCalendar} 
              date={this.state.date}
              type="tablero"
            />
            <Calendar 
              className={this.state.calendarState} 
              locale={locale} 
              onChange={this.changeDate} />
          </div>
      )}}/>
      <Route path='/home/admin' render={() => {
        return(
          <Admin 
            changeLang={this.props.changeLang}
            version={this.props.version}
            language={lang}
            url={url}
            tkn={tkn}
            msg={this.props.msg}
            loged={this.props.loged}
            logOut={this.props.logOut}/>
      )}}/>
      </div>
    );
  }
}

export default VisualApp;


// WEBPACK FOOTER //
// ./src/Components/VisualApp.js